import axios from "axios";
import crudApi from "./crudApi";
import {
    API_DEFAULT_LOT_MANAGEMENT_DIRECTIVES,
    API_LOT_MANAGEMENT_DIRECTIVES
} from '../api.js';

class LotManagementDirective extends crudApi {
    async updateOrCreateDefault(data, options = {}) {
        return await axios.post(API_DEFAULT_LOT_MANAGEMENT_DIRECTIVES, data, options);
    }
}
export default new LotManagementDirective(API_LOT_MANAGEMENT_DIRECTIVES)
